<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 确保页面可以正常滚动
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.height = 'auto';
    document.body.style.position = 'static';
  }
}
</script>

<style>
/* 全局样式将在这里引入 */
@import './assets/css/common.css';

/* 确保页面可滚动 */
html, body {
  overflow: auto !important;
  height: auto !important;
}

#app {
  min-height: 100vh;
}
</style>